import type { UiTypes } from "various-ui";
import type { ExtractPropTypes } from "vue";
import type { LayoutProps } from "../../index";

export const ModulePropsOption = {
    origin: { type: Object as PropType<LayoutProps>, required: true },
} as const;

export type ModuleProps = ExtractPropTypes<typeof ModulePropsOption>;


export interface ModuleInfo {
    index: number;
    classification: string;
    characterization: string;
    HPO_rate: string;
    orphanet_rate: string;
    source: string;
}

export interface ModuleData {
    count: number;
    page: number;
    data: ModuleInfo[];
    filters: UiTypes.candidate[];
}
